import React, { ReactNode } from 'react';

export interface LayoutSidebarProps {
  header?: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export const LayoutSidebar: React.FC<LayoutSidebarProps> = ({
  header,
  content,
  footer,
  className = '',
}) => {
  return (
    <div className={`h-full flex flex-col ${className}`}>
      {/* Fixed Header Section */}
      {header && <div className="flex-shrink-0 border-b border-base-300">{header}</div>}

      {/* Scrollable Content Section */}
      <div className="flex-1 overflow-y-auto">{content}</div>

      {/* Fixed Footer Section */}
      {footer && <div className="flex-shrink-0 border-t border-base-300">{footer}</div>}
    </div>
  );
};
